import { render, staticRenderFns } from "./editResultButton.vue?vue&type=template&id=29b01c55&"
import script from "./editResultButton.vue?vue&type=script&lang=js&"
export * from "./editResultButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports